import { brand } from '@/config/brands'

/**
 * Setting 页面样式配置
 * 根据品牌返回不同的样式
 */

const defaultStyles = {
  cardPaddingX: 'px-20px',
  pageMarginX: 'mx-10px',
}

const brandStyles: Record<string, Partial<typeof defaultStyles>> = {
  novelarc: {
    cardPaddingX: '',
    pageMarginX: 'mx-10px',
  },
  storyella: {
    cardPaddingX: '',
    pageMarginX: 'mx-10px',
  },
}

export const settingStyles = {
  ...defaultStyles,
  ...brandStyles[brand],
}
